import { clearTokens } from '../api/axios'
import { NuiCallbacks } from '../utils/ClientEvents'
import { api } from './api'
import { ClientApi } from './clientApi'

export interface JWTData {
    accessToken: string
    refreshToken: string
}

export interface LoginData {
    userId: number
    userName: string
}

export default class AuthService {

    static async tryFetchJwtFromClient() {
        const data = await ClientApi.request<JWTData>(
            NuiCallbacks.FETCH_JWT,
            {}
        )

        if (data) {
            localStorage.setItem('accessToken', data.accessToken)
            localStorage.setItem('refreshToken', data.refreshToken)
            return data
        }

        return null
    }

    static async loginWithAccessToken(playerId: number): Promise<LoginData> {
        const response = await api.post('/auth/jwt/authenticate', { playerId })
        return response.data
    }

    static async refreshAccessToken(): Promise<JWTData | null> {
        const response = await api.post(
            '/auth/refresh-token',
            { refreshToken: localStorage.getItem('refreshToken') },
        )

        if (response.data) {
            localStorage.setItem('accessToken', response.data.accessToken)
            localStorage.setItem('refreshToken', response.data.refreshToken)
            try {
                ClientApi.send(NuiCallbacks.SAVE_JWT, { accessToken: response.data.accessToken, refreshToken: response.data.refreshToken })
            } catch (e) {
                console.log('Failed to save JWT on client', e)
            }
            return response.data
        }

        return null
    }

    static logout = () => {
        const refreshToken = localStorage.getItem('refreshToken')
        api.post('/auth/logout', { refreshToken })
            .then(() => {
                clearTokens()
                localStorage.removeItem('userId')
            })
    }
} 